import React, { useState, useEffect } from 'react';
import {
  Container, Card, Table, Button, Row, Col, Form, Badge, Pagination,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import {
  FaPlus, FaEdit, FaTrash, FaFileAlt, FaClipboardList,
  FaCog, FaSortUp, FaSortDown, FaSort, FaComments,
} from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import {
  getSolicitaDebMunicipioGruposEmpresa,
  getSolicitaDebMunicipioContas,
  getSolicitaDebMunicipioTipos,
  getSolicitaDebMunicipioStatus,
  listarSolicitaDebMunicipio,
  excluirSolicitaDebMunicipio,
} from '~/Services/Service';
import NovaSolicitacaoModal from './NovaSolicitacaoModal';
import AlterarStatusModal from './AlterarStatusModal';
import GerarRequerimentoModal from './GerarRequerimentoModal';
import TiposSolicitacaoModal from './TiposSolicitacaoModal';
import SolicitaDebMunicipioOcorrenciaDrawer from './SolicitaDebMunicipioOcorrenciaDrawer';
import './index.scss';

const STATUS_CORES = {
  0: '#ffc107',
  3: '#28a745',
};

const PREFIXO_DEBITOS = 'SOLICITAÇÃO DE DÉBITOS';
const TAMANHOS_PAGINA = [10, 25, 50, 100];

const DebitosMunicipais = () => {
  const usuario = AuthStorage.getUser() || {};
  const codigoUsuario = usuario.codigo_usuario || usuario.Codigo_Usuario || 0;
  const isResponsavel = AuthStorage.temCaracteristicas([caracteristicas.RespDebMunicipaisCond]);

  const [filtros, setFiltros] = useState({
    codigo_familia: null,
    codigo_grupo_empresa: null,
    codigo_conta: null,
    dt_ini: '',
    dt_fim: '',
    status: null,
    codigo_tipo_solicitacao: null,
    codigo_usuario: null,
  });

  const empreendimentosRedux = useSelector((state) => state.empreendimentos);
  const optionsEmpreendimentos = (empreendimentosRedux && empreendimentosRedux.sort
    ? empreendimentosRedux.sort
    : []).map((item) => ({
    value: item.codigo,
    label: `${item.codigo} - ${item.descricao}`,
  }));
  const [registros, setRegistros] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selecionados, setSelecionados] = useState(new Set());
  const [ordenacao, setOrdenacao] = useState({ campo: 'dt_inicio', direcao: 'desc' });
  const [pagina, setPagina] = useState(1);
  const [tamanhoPagina, setTamanhoPagina] = useState(25);
  const [modalAtivo, setModalAtivo] = useState(null);
  const [registroAtivo, setRegistroAtivo] = useState(null);
  const [confirmacao, setConfirmacao] = useState({ show: false, item: null });

  const [gruposEmpresa, setGruposEmpresa] = useState([]);
  const [contas, setContas] = useState([]);
  const [tiposSolicitacao, setTiposSolicitacao] = useState([]);
  const [statusList, setStatusList] = useState([]);

  const recarregarTiposSolicitacao = async () => {
    try {
      const respTipos = await getSolicitaDebMunicipioTipos();
      setTiposSolicitacao(
        (respTipos || []).map((t) => ({ value: t.codigo, label: `${t.codigo} - ${t.assunto}`, assunto: t.assunto }))
      );
    } catch (err) {
      toast.error('Erro ao recarregar tipos de solicitação.');
    }
  };

  useEffect(() => {
    const carregarCombos = async () => {
      try {
        const [respGe, respTipos, respStatus] = await Promise.all([
          getSolicitaDebMunicipioGruposEmpresa(),
          getSolicitaDebMunicipioTipos(),
          getSolicitaDebMunicipioStatus(),
        ]);
        setGruposEmpresa(
          (respGe || []).map((g) => ({ value: g.codigo, label: `${g.codigo} - ${g.apelido}` }))
        );
        setTiposSolicitacao(
          (respTipos || []).map((t) => ({ value: t.codigo, label: `${t.codigo} - ${t.assunto}`, assunto: t.assunto }))
        );
        setStatusList(
          (respStatus || []).map((s) => ({ value: s.codigo, label: `${s.codigo} - ${s.nome}` }))
        );
      } catch (err) {
        toast.error('Erro ao carregar opções de filtro.');
      }
    };
    carregarCombos();
  }, []);

  useEffect(() => {
    if (filtros.codigo_grupo_empresa) {
      const carregarContas = async () => {
        try {
          const resp = await getSolicitaDebMunicipioContas(filtros.codigo_grupo_empresa);
          setContas(
            (resp || []).map((c) => ({ value: c.codigo, label: `${c.codigo} - ${c.apelido}` }))
          );
        } catch (err) {
          setContas([]);
        }
      };
      carregarContas();
    } else {
      setContas([]);
      setFiltros((prev) => ({ ...prev, codigo_conta: null }));
    }
  }, [filtros.codigo_grupo_empresa]);

  const handleFiltrar = async () => {
    setLoading(true);
    setSelecionados(new Set());
    try {
      const params = {
        codigoFamilia: filtros.codigo_familia || undefined,
        codigoGrupoEmpresa: filtros.codigo_grupo_empresa || undefined,
        codigoConta: filtros.codigo_conta || undefined,
        dtIni: filtros.dt_ini || undefined,
        dtFim: filtros.dt_fim || undefined,
        status: filtros.status != null ? filtros.status : undefined,
        codigoTipoSolicitacao: filtros.codigo_tipo_solicitacao || undefined,
        codigoUsuarioResponsavel: filtros.codigo_usuario || undefined,
      };
      const resp = await listarSolicitaDebMunicipio(params);
      const registros = Array.isArray(resp) ? resp : [];
      setRegistros(registros);
      setTotal(registros.length);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLimpar = () => {
    setFiltros({
      codigo_familia: null,
      codigo_grupo_empresa: null,
      codigo_conta: null,
      dt_ini: '',
      dt_fim: '',
      status: null,
      codigo_tipo_solicitacao: null,
      codigo_usuario: null,
    });
    setRegistros([]);
    setTotal(0);
    setSelecionados(new Set());
  };

  const handleToggleSelecionado = (codigo) => {
    setSelecionados((prev) => {
      const next = new Set(prev);
      if (next.has(codigo)) {
        next.delete(codigo);
      } else {
        next.add(codigo);
      }
      return next;
    });
  };

  const handleOrdenacao = (campo) => {
    setOrdenacao((prev) => ({
      campo,
      direcao: prev.campo === campo && prev.direcao === 'asc' ? 'desc' : 'asc',
    }));
  };

  const iconeOrdenacao = (campo) => {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  const thSortStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

  const registrosOrdenados = [...registros].sort((a, b) => {
    const dir = ordenacao.direcao === 'asc' ? 1 : -1;
    const va = a[ordenacao.campo];
    const vb = b[ordenacao.campo];
    if (va == null) return 1 * dir;
    if (vb == null) return -1 * dir;
    if (typeof va === 'string') return va.localeCompare(vb) * dir;
    return (va - vb) * dir;
  });

  const totalPaginas = Math.max(1, Math.ceil(registrosOrdenados.length / tamanhoPagina));
  const paginaAtual = Math.min(pagina, totalPaginas);
  const inicioIdx = (paginaAtual - 1) * tamanhoPagina;
  const fimIdx = Math.min(inicioIdx + tamanhoPagina, registrosOrdenados.length);
  const registrosPagina = registrosOrdenados.slice(inicioIdx, fimIdx);

  useEffect(() => {
    setPagina(1);
  }, [registros, ordenacao.campo, ordenacao.direcao, tamanhoPagina]);

  const irParaPagina = (p) => {
    if (p < 1 || p > totalPaginas) return;
    setPagina(p);
  };

  const paginasVisiveis = () => {
    const maxBotoes = 7;
    if (totalPaginas <= maxBotoes) {
      return Array.from({ length: totalPaginas }, (_, i) => i + 1);
    }
    const ini = Math.max(1, paginaAtual - 3);
    const fim = Math.min(totalPaginas, ini + maxBotoes - 1);
    const iniAjustado = Math.max(1, fim - maxBotoes + 1);
    return Array.from({ length: fim - iniAjustado + 1 }, (_, i) => iniAjustado + i);
  };

  const getRowStyle = (reg) => {
    const dias = reg.qtd_dias != null ? reg.qtd_dias : 0;
    if (reg.dt_fim == null && dias >= 10) {
      return { backgroundColor: '#ffcccc', fontWeight: 'bold' };
    }
    if (reg.tipo_solicitacao && reg.tipo_solicitacao.charAt(0) === 'E') {
      return { backgroundColor: '#C4C4FF' };
    }
    return {};
  };

  const registrosSelecionadosArray = registros.filter((r) => selecionados.has(r.codigo));

  const handleExcluir = (reg) => {
    setConfirmacao({ show: true, item: reg });
  };

  const handleConfirmarExclusao = async (confirmado) => {
    if (!confirmado) {
      setConfirmacao({ show: false, item: null });
      return;
    }
    const item = confirmacao.item;
    setConfirmacao({ show: false, item: null });
    try {
      await excluirSolicitaDebMunicipio(item.codigo);
      toast.success('Solicitação excluída com sucesso.');
      handleFiltrar();
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleSuccessModal = () => {
    setModalAtivo(null);
    setRegistroAtivo(null);
    setSelecionados(new Set());
    handleFiltrar();
  };

  const abrirModal = (tipo, reg) => {
    setRegistroAtivo(reg || null);
    setModalAtivo(tipo);
  };

  return (
    <Container fluid className="px-3 py-3">
      <Header title="Atendimento — Débitos Municipais e Atualização Cadastral" />

      {/* Card de Filtros */}
      <Card className="shadow-sm mb-3">
        <Card.Body className="py-2">
          <Row className="align-items-end">
            <Col md={3} className="mb-2">
              <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                Empreendimento
              </Form.Label>
              <Select
                placeholder="Todos"
                isClearable
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={optionsEmpreendimentos}
                value={optionsEmpreendimentos.find((e) => e.value === filtros.codigo_familia) || null}
                onChange={(opt) =>
                  setFiltros((prev) => ({
                    ...prev,
                    codigo_familia: opt ? opt.value : null,
                  }))
                }
              />
            </Col>
            <Col md={3} className="mb-2">
              <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                Grupo Empresa
              </Form.Label>
              <Select
                placeholder="Todos"
                isClearable
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={gruposEmpresa}
                value={gruposEmpresa.find((g) => g.value === filtros.codigo_grupo_empresa) || null}
                onChange={(opt) =>
                  setFiltros((prev) => ({
                    ...prev,
                    codigo_grupo_empresa: opt ? opt.value : null,
                    codigo_conta: null,
                  }))
                }
              />
            </Col>
            <Col md={2} className="mb-2">
              <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                Conta
              </Form.Label>
              <Select
                placeholder="Todas"
                isClearable
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={contas}
                value={contas.find((c) => c.value === filtros.codigo_conta) || null}
                onChange={(opt) =>
                  setFiltros((prev) => ({ ...prev, codigo_conta: opt ? opt.value : null }))
                }
                isDisabled={!filtros.codigo_grupo_empresa}
              />
            </Col>
            <Col md={2} className="mb-2">
              <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                Status
              </Form.Label>
              <Select
                placeholder="Todos"
                isClearable
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={statusList}
                value={statusList.find((s) => s.value === filtros.status) || null}
                onChange={(opt) =>
                  setFiltros((prev) => ({ ...prev, status: opt ? opt.value : null }))
                }
              />
            </Col>
            <Col md={2} className="mb-2">
              <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                Tipo de Solicitação
              </Form.Label>
              <Select
                placeholder="Todos"
                isClearable
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={tiposSolicitacao}
                value={
                  tiposSolicitacao.find((t) => t.value === filtros.codigo_tipo_solicitacao) || null
                }
                onChange={(opt) =>
                  setFiltros((prev) => ({
                    ...prev,
                    codigo_tipo_solicitacao: opt ? opt.value : null,
                  }))
                }
              />
            </Col>
          </Row>
          <Row className="align-items-end">
            <Col md={2} className="mb-2">
              <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                Data De
              </Form.Label>
              <Form.Control
                type="date"
                value={filtros.dt_ini}
                onChange={(e) => setFiltros({ ...filtros, dt_ini: e.target.value })}
                onBlur={(e) => setFiltros({ ...filtros, dt_ini: e.target.value })}
              />
            </Col>
            <Col md={2} className="mb-2">
              <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                Data Até
              </Form.Label>
              <Form.Control
                type="date"
                value={filtros.dt_fim}
                onChange={(e) => setFiltros({ ...filtros, dt_fim: e.target.value })}
                onBlur={(e) => setFiltros({ ...filtros, dt_fim: e.target.value })}
              />
            </Col>
            <Col md={8} className="mb-2 text-right">
              <Button variant="outline-secondary" className="mr-2" onClick={handleLimpar}>
                Limpar
              </Button>
              <Button variant="primary" className="mr-2" onClick={handleFiltrar}>
                Filtrar
              </Button>
              <Button
                variant="success"
                className="mr-2"
                onClick={() => abrirModal('nova', null)}
              >
                <FaPlus className="mr-1" /> Nova Solicitação
              </Button>
              <Button
                variant="warning"
                className="mr-2"
                disabled={selecionados.size === 0}
                onClick={() => abrirModal('alterar', null)}
              >
                <FaEdit className="mr-1" /> Alterar Status ({selecionados.size})
              </Button>
              <Button
                variant="info"
                className="mr-2"
                disabled={selecionados.size !== 1}
                onClick={() => {
                  const reg = registros.find((r) => selecionados.has(r.codigo));
                  abrirModal('requerimento', reg);
                }}
              >
                <FaFileAlt className="mr-1" /> Requerimento
              </Button>
              <Button
                variant="secondary"
                onClick={() => abrirModal('tipos', null)}
              >
                <FaCog className="mr-1" /> Tipos
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Card de Dados */}
      <Card className="shadow-sm">
        <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff' }}>
          <strong>Solicitações</strong>{' '}
          <Badge variant="light" style={{ fontSize: '0.85rem' }}>{total}</Badge>
          {selecionados.size > 0 && (
            <span className="ml-3" style={{ fontSize: '0.85rem', opacity: 0.85 }}>
              {selecionados.size} selecionada(s)
            </span>
          )}
        </Card.Header>
        <Card.Body className="p-0">
          {loading ? (
            <div className="p-3"><Loading /></div>
          ) : (
            <>
              {/* Desktop */}
              <div className="debitos-desktop">
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead>
                    <tr style={{ backgroundColor: '#f0f0f0' }}>
                      <th style={{ width: 36 }}>
                        <Form.Check
                          type="checkbox"
                          checked={registros.length > 0 && selecionados.size === registros.length}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelecionados(new Set(registros.map((r) => r.codigo)));
                            } else {
                              setSelecionados(new Set());
                            }
                          }}
                        />
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('codigo')}>
                        # {iconeOrdenacao('codigo')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('nome_empreendimento')}>
                        Empreendimento {iconeOrdenacao('nome_empreendimento')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('apelido_conta')}>
                        Conta {iconeOrdenacao('apelido_conta')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('codigo_boleto')}>
                        Boleto {iconeOrdenacao('codigo_boleto')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('cliente_nome')}>
                        Cliente {iconeOrdenacao('cliente_nome')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('tipo_solicitacao')}>
                        Tipo {iconeOrdenacao('tipo_solicitacao')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('status_nome')}>
                        Status {iconeOrdenacao('status_nome')}
                      </th>
                      <th style={thSortStyle} onClick={() => handleOrdenacao('dt_inicio')}>
                        Data {iconeOrdenacao('dt_inicio')}
                      </th>
                      <th style={{ width: 90 }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {registrosPagina.length === 0 ? (
                      <tr>
                        <td colSpan={10} className="text-center py-3 text-muted">
                          Nenhum registro encontrado. Use os filtros acima e clique em Filtrar.
                        </td>
                      </tr>
                    ) : (
                      registrosPagina.map((reg) => (
                        <tr key={reg.codigo} style={getRowStyle(reg)}>
                          <td>
                            <Form.Check
                              type="checkbox"
                              checked={selecionados.has(reg.codigo)}
                              onChange={() => handleToggleSelecionado(reg.codigo)}
                            />
                          </td>
                          <td>{reg.codigo}</td>
                          <td>{reg.nome_empreendimento}</td>
                          <td>{reg.apelido_conta}</td>
                          <td>{reg.codigo_boleto}</td>
                          <td>{reg.cliente_nome}</td>
                          <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {reg.tipo_solicitacao}
                          </td>
                          <td>
                            <Badge
                              style={{
                                backgroundColor: STATUS_CORES[reg.status] || '#6c757d',
                                color: '#fff',
                              }}
                            >
                              {reg.status_nome}
                            </Badge>
                          </td>
                          <td>
                            {reg.dt_inicio
                              ? new Date(reg.dt_inicio).toLocaleDateString('pt-BR')
                              : '-'}
                          </td>
                          <td>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              className="mr-1"
                              title="Ocorrências"
                              onClick={() => abrirModal('ocorrencias', reg)}
                            >
                              <FaComments />
                            </Button>
                            {isResponsavel && (
                              <Button
                                variant="outline-danger"
                                size="sm"
                                title="Excluir"
                                onClick={() => handleExcluir(reg)}
                              >
                                <FaTrash />
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>

              {/* Mobile */}
              <div className="debitos-mobile p-2">
                {registrosPagina.length === 0 ? (
                  <p className="text-center text-muted py-3">
                    Nenhum registro. Use os filtros e clique em Filtrar.
                  </p>
                ) : (
                  registrosPagina.map((reg) => (
                    <Card key={reg.codigo} className="mb-2 shadow-sm" style={getRowStyle(reg)}>
                      <Card.Body className="py-2 px-3">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <strong>#{reg.codigo}</strong>
                          <Badge
                            style={{
                              backgroundColor: STATUS_CORES[reg.status] || '#6c757d',
                              color: '#fff',
                            }}
                          >
                            {reg.status_nome}
                          </Badge>
                        </div>
                        <div style={{ fontSize: '0.85rem' }}>
                          <div><strong>Empreendimento:</strong> {reg.nome_empreendimento}</div>
                          <div><strong>Grupo Empresa:</strong> {reg.nome_grupo_empresa}</div>
                          <div><strong>Conta:</strong> {reg.apelido_conta}</div>
                          <div><strong>Boleto:</strong> {reg.codigo_boleto}</div>
                          <div><strong>Cliente:</strong> {reg.cliente_nome}</div>
                          <div><strong>Tipo:</strong> {reg.tipo_solicitacao}</div>
                          <div><strong>Data:</strong> {reg.dt_inicio ? new Date(reg.dt_inicio).toLocaleDateString('pt-BR') : '-'}</div>
                        </div>
                        <div className="mt-2 d-flex">
                          <Form.Check
                            type="checkbox"
                            label="Selecionar"
                            checked={selecionados.has(reg.codigo)}
                            onChange={() => handleToggleSelecionado(reg.codigo)}
                            className="mr-3"
                          />
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="mr-2"
                            onClick={() => abrirModal('ocorrencias', reg)}
                          >
                            <FaComments /> Ocorrências
                          </Button>
                          {isResponsavel && (
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => handleExcluir(reg)}
                            >
                              <FaTrash />
                            </Button>
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                  ))
                )}
              </div>

              {/* Paginação */}
              {registrosOrdenados.length > 0 && (
                <div className="d-flex flex-wrap align-items-center justify-content-between px-3 py-2 border-top">
                  <div style={{ fontSize: '0.85rem' }} className="text-muted">
                    Exibindo <strong>{inicioIdx + 1}</strong>–<strong>{fimIdx}</strong> de{' '}
                    <strong>{registrosOrdenados.length}</strong>
                  </div>
                  <div className="d-flex align-items-center">
                    <Form.Label className="mb-0 mr-2" style={{ fontSize: '0.85rem' }}>
                      Por página:
                    </Form.Label>
                    <Form.Control
                      as="select"
                      size="sm"
                      value={tamanhoPagina}
                      onChange={(e) => setTamanhoPagina(Number(e.target.value))}
                      style={{ width: 80 }}
                      className="mr-3"
                    >
                      {TAMANHOS_PAGINA.map((n) => (
                        <option key={n} value={n}>{n}</option>
                      ))}
                    </Form.Control>
                    <Pagination size="sm" className="mb-0">
                      <Pagination.First
                        disabled={paginaAtual === 1}
                        onClick={() => irParaPagina(1)}
                      />
                      <Pagination.Prev
                        disabled={paginaAtual === 1}
                        onClick={() => irParaPagina(paginaAtual - 1)}
                      />
                      {paginasVisiveis()[0] > 1 && <Pagination.Ellipsis disabled />}
                      {paginasVisiveis().map((p) => (
                        <Pagination.Item
                          key={p}
                          active={p === paginaAtual}
                          onClick={() => irParaPagina(p)}
                        >
                          {p}
                        </Pagination.Item>
                      ))}
                      {paginasVisiveis()[paginasVisiveis().length - 1] < totalPaginas && (
                        <Pagination.Ellipsis disabled />
                      )}
                      <Pagination.Next
                        disabled={paginaAtual === totalPaginas}
                        onClick={() => irParaPagina(paginaAtual + 1)}
                      />
                      <Pagination.Last
                        disabled={paginaAtual === totalPaginas}
                        onClick={() => irParaPagina(totalPaginas)}
                      />
                    </Pagination>
                  </div>
                </div>
              )}
            </>
          )}
        </Card.Body>
      </Card>

      {/* Modais */}
      <NovaSolicitacaoModal
        show={modalAtivo === 'nova'}
        onHide={() => { setModalAtivo(null); setRegistroAtivo(null); }}
        onSuccess={handleSuccessModal}
        gruposEmpresa={gruposEmpresa}
        tiposSolicitacao={tiposSolicitacao}
      />

      <AlterarStatusModal
        show={modalAtivo === 'alterar'}
        onHide={() => { setModalAtivo(null); setSelecionados(new Set()); }}
        onSuccess={handleSuccessModal}
        solicitacoesSelecionadas={registrosSelecionadosArray}
        statusList={statusList}
        tiposSolicitacao={tiposSolicitacao}
      />

      <GerarRequerimentoModal
        show={modalAtivo === 'requerimento'}
        onHide={() => { setModalAtivo(null); setRegistroAtivo(null); }}
        onSuccess={handleSuccessModal}
        solicitacao={registroAtivo}
      />

      <TiposSolicitacaoModal
        show={modalAtivo === 'tipos'}
        onHide={() => {
          setModalAtivo(null);
          recarregarTiposSolicitacao();
        }}
      />

      <SolicitaDebMunicipioOcorrenciaDrawer
        open={modalAtivo === 'ocorrencias'}
        onClose={() => { setModalAtivo(null); setRegistroAtivo(null); }}
        codigoSolicitacao={registroAtivo ? registroAtivo.codigo : null}
        codigoUsuario={codigoUsuario}
      />

      <ModalConfirmacao
        show={confirmacao.show}
        title="Excluir Solicitação"
        message={
          confirmacao.item
            ? `Confirma a exclusão da solicitação #${confirmacao.item.codigo}?`
            : ''
        }
        onClose={handleConfirmarExclusao}
      />
    </Container>
  );
};

export default DebitosMunicipais;
